function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useContext, useEffect, useRef } from 'react';
import QRCode from 'qrcode.react';
import { context, usePrefersColor } from 'dumi/theme';
import { ROUTE_MSG_TYPE } from '../layouts/demo';
import './Device.less';

var Device = function Device(_ref) {
  var url = _ref.url,
      className = _ref.className;
  var iframeRef = useRef();

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      iframeSrc = _useState2[0],
      setIframeSrc = _useState2[1];

  var _useState3 = useState(Math.random()),
      _useState4 = _slicedToArray(_useState3, 2),
      renderKey = _useState4[0],
      setRenderKey = _useState4[1];

  var _usePrefersColor = usePrefersColor(),
      _usePrefersColor2 = _slicedToArray(_usePrefersColor, 1),
      color = _usePrefersColor2[0];

  var _useContext = useContext(context),
      _useContext$config = _useContext.config,
      mode = _useContext$config.mode,
      theme = _useContext$config.theme;

  var carrier = (theme === null || theme === void 0 ? void 0 : theme.carrier) || 'dumi'; // re-render iframe if prefers color changed

  useEffect(function () {
    setRenderKey(Math.random());
  }, [color]); // control iframe page update

  useEffect(function () {
    var origin = window.location.origin;

    if (!iframeSrc || !(url === null || url === void 0 ? void 0 : url.startsWith(origin))) {
      // set iframe src directly if it is the first render or custom url
      setIframeSrc(url);
    } else {
      var _window, _iframeRef$current;

      var pathname = url // discard origin prefix
      .replace(origin, '') // discard router base
      .replace("".concat(((_window = window) === null || _window === void 0 ? void 0 : _window.routerBase) || '').replace(/\/$/, ''), ''); // update iframe page route via postmessage, to avoid page refresh

      (_iframeRef$current = iframeRef.current) === null || _iframeRef$current === void 0 ? void 0 : _iframeRef$current.contentWindow.postMessage({
        type: ROUTE_MSG_TYPE,
        value: pathname
      }, '*');
    }
  }, [url]);
  return /*#__PURE__*/React.createElement("div", {
    className: ['__dumi-default-device'].concat(className).join(' ') // avoid device flicker when using custom compiletime to render simulator
    ,
    "data-device-type": iframeSrc ? 'iOS' : 'none',
    "data-mode": mode
  }, /*#__PURE__*/React.createElement("div", {
    className: "__dumi-default-device-status"
  }, /*#__PURE__*/React.createElement("span", {
    className: "__dumi-default-device-status-carrier"
  }, carrier), /*#__PURE__*/React.createElement("span", null, "10:24")), /*#__PURE__*/React.createElement("iframe", {
    ref: iframeRef,
    title: "dumi-previewer",
    src: iframeSrc,
    key: renderKey
  }), /*#__PURE__*/React.createElement("div", {
    className: "__dumi-default-device-action"
  }, /*#__PURE__*/React.createElement("button", {
    className: "__dumi-default-icon",
    role: "refresh",
    onClick: function onClick() {
      return setRenderKey(Math.random());
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "__dumi-default-icon",
    role: "qrcode"
  }, url && /*#__PURE__*/React.createElement(QRCode, {
    value: url,
    size: 96
  })), /*#__PURE__*/React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer",
    className: "__dumi-default-icon",
    role: "open-demo"
  })));
};

export default Device;